import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["aria-label"]
const _hoisted_2 = { class: "step-list" }
const _hoisted_3 = { class: "step-item" }
const _hoisted_4 = { class: "step-item" }
const _hoisted_5 = { class: "step-item" }
const _hoisted_6 = { class: "step-item" }
const _hoisted_7 = { class: "step-item" }
const _hoisted_8 = { class: "step-item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Step = _resolveComponent("Step")!

  return (_openBlock(), _createElementBlock("nav", {
    class: "step-bar-container",
    "aria-label": _ctx.$t('aria.barre.etapes.intervention')
  }, [
    _createElementVNode("ol", _hoisted_2, [
      _createElementVNode("li", _hoisted_3, [
        _createVNode(_component_Step, {
          state: _ctx.isActive(1),
          number: 1,
          title: _ctx.$t('intervention.bar.site'),
          subtitle: _ctx.site?.description ?? ''
        }, null, 8, ["state", "title", "subtitle"])
      ]),
      _cache[0] || (_cache[0] = _createElementVNode("div", {
        class: "separator",
        "aria-hidden": "true"
      }, null, -1)),
      _createElementVNode("li", _hoisted_4, [
        _createVNode(_component_Step, {
          state: _ctx.isActive(2),
          number: 2,
          title: _ctx.$t('intervention.bar.type'),
          subtitle: _ctx.type?.libelle ?? ''
        }, null, 8, ["state", "title", "subtitle"])
      ]),
      _cache[1] || (_cache[1] = _createElementVNode("div", {
        class: "separator",
        "aria-hidden": "true"
      }, null, -1)),
      _createElementVNode("li", _hoisted_5, [
        _createVNode(_component_Step, {
          state: _ctx.isActive(3),
          number: 3,
          title: _ctx.$t('intervention.bar.equipement'),
          subtitle: _ctx.equipement
        }, null, 8, ["state", "title", "subtitle"])
      ]),
      _cache[2] || (_cache[2] = _createElementVNode("div", {
        class: "separator",
        "aria-hidden": "true"
      }, null, -1)),
      _createElementVNode("li", _hoisted_6, [
        _createVNode(_component_Step, {
          state: _ctx.isActive(4),
          number: 4,
          title: _ctx.$t('intervention.bar.object'),
          subtitle: _ctx.objet
        }, null, 8, ["state", "title", "subtitle"])
      ]),
      _cache[3] || (_cache[3] = _createElementVNode("div", {
        class: "separator",
        "aria-hidden": "true"
      }, null, -1)),
      _createElementVNode("li", _hoisted_7, [
        _createVNode(_component_Step, {
          state: _ctx.isActive(5),
          number: 5,
          title: _ctx.$t('intervention.bar.recurrence')
        }, null, 8, ["state", "title"])
      ]),
      _cache[4] || (_cache[4] = _createElementVNode("div", {
        class: "separator",
        "aria-hidden": "true"
      }, null, -1)),
      _createElementVNode("li", _hoisted_8, [
        _createVNode(_component_Step, {
          state: _ctx.isActive(6),
          number: 6,
          title: _ctx.$t('intervention.bar.recap')
        }, null, 8, ["state", "title"])
      ])
    ])
  ], 8, _hoisted_1))
}